import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { FilterSubitemKepValues } from '../validation'
import type { PengurusKepDataType } from './types'
import type { MutationPengurusKepValues } from './validation'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['kep-pimpinan', key] as const

const getAll = (
  params?: FilterSubitemKepValues
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<PengurusKepDataType>>
> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<PengurusKepDataType>>
      >(`/kelembagaan/kep/${params?.id_kep}/pimpinan`, {
        params: {
          ...params,
          id_kep: undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const create = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<PengurusKepDataType>,
  MutationPengurusKepValues
> => ({
  mutationFn: async (data: MutationPengurusKepValues) => {
    try {
      const response = await api.post<
        ServiceGetByIdResponse<PengurusKepDataType>
      >(`/kelembagaan/kep/${data?.id_kep}/pimpinan`, {
        ...data
      })
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const update = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<PengurusKepDataType>,
  MutationPengurusKepValues
> => ({
  mutationFn: async (data: MutationPengurusKepValues) => {
    try {
      const response = await api.put<
        ServiceGetByIdResponse<PengurusKepDataType>
      >(`/kelembagaan/kep/${data?.id_kep}/pimpinan/${data.id_pengurus}`, {
        ...data
      })
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const deleteData = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<PengurusKepDataType>,
  { id_kep: string; id_data: string }
> => ({
  mutationFn: async (data: { id_kep: string; id_data: string }) => {
    try {
      const response = await api.delete<
        ServiceGetByIdResponse<PengurusKepDataType>
      >(`/kelembagaan/kep/${data?.id_kep}/pimpinan/${data?.id_data}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const pengurusKep = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  create,
  update,
  deleteData
}
